import React from "react";
import ErrorIcon from "@material-ui/icons/Error";
import { Typography } from "@material-ui/core";
import ErrorBoundary from "../ErrorBoundary";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Dash from "../admin/Dash";
import {
    changePage,
    checkInternetConnection,
    DESIGNER_PAGE,
    MAIN_PAGE,
    resetDesigner,
    setDesignerLoadingBackdrop,
    SHOW_LOADING_BACKDROP,
    UPDATE_APP,
    updateDesigner,
} from "../redux_store/appState";
import { loadJob } from "../redux_store/jobState";
import { mergedState } from "../redux_store";
import { deleteCookie, getCookie, setCookie, useInterval } from "../components/Common";
import Augmented from "../augmented_reality/Augmented";

export const AppRedirects = ({ user, theme, bomTestResult }) => {
    const url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    if (url.includes("?dash") && user?.Role === 99) {
        return (
            <ErrorBoundary>
                <MuiThemeProvider theme={theme}>
                    <Dash />
                </MuiThemeProvider>
            </ErrorBoundary>
        );
    }

    // Beta
    if (url.includes("init-beta")) {
        const token = params.get("CTK");
        const userName = params.get("SFU");

        // Check if cookies already exist
        const cookies = document.cookie;

        const hasToken = cookies.includes("CDS_token=");
        const hasUser = cookies.includes("SF_user=");

        if (!hasToken && token) {
            document.cookie = `CDS_token=${token}; path=/; secure`;
        }

        if (!hasUser && userName) {
            document.cookie = `SF_user=${userName}; path=/; secure`;
        }
    }

    // Augmented Reality
    if (window.location.href.includes("3d-viewer")) {
        return <Augmented />;
    }

    if (window.location.href.includes("bom-auto-test") && user?.Role === 99) {
        return <h3 style={{ fontWeight: "bold", padding: 20 }}>{bomTestResult}</h3>;
    }
};
// Delicious 🍪
export const CheckCookies = ({ online, config, dispatch }) => {
    useInterval(() => {
        if (window.debug && window.location.href.includes("use_cache") && getCookie("CDS_token")) return;
        if (!online && !document.hidden) {
            //
            checkInternetConnection(dispatch);
        }
    }, 3000);

    if (window.debug) {
        return;
    }

    let CDS_token_id = getCookie("CDS_token_id");

    // Check if CDS_token_id needs to be updated
    if (
        CDS_token_id &&
        CDS_token_id !== "" &&
        CDS_token_id !== String(config?.CDS_token_id) &&
        config?.CDS_token_id &&
        getCookie("CDS_token")
    ) {
        deleteCookie("CDS_token");
        deleteCookie("SF_user");
        setCookie("CDS_token_id", config.CDS_token_id);
        window.location.reload(true);
    }

    // Handle the case where CDS_token_id is an empty string and update the cookie
    if (CDS_token_id === "" && config?.CDS_token_id) {
        setCookie("CDS_token_id", config.CDS_token_id);
    }
};

export const loadDefaultJob = async ({ jobid, dispatch, user }) => {
    try {
        const business_code = user?.BusinessDetails?.Code;
        dispatch(changePage(DESIGNER_PAGE));
        dispatch(setDesignerLoadingBackdrop(`Loading #${jobid}`));

        let result = await dispatch(loadJob(business_code, jobid, user));
        if (!result) {
            result = await dispatch(loadJob(business_code, jobid, user));
        }

        if (!result) {
            dispatch(
                setDesignerLoadingBackdrop(
                    <div onClick={() => loadDefaultJob({ jobid, dispatch, user })}>
                        <ErrorIcon style={{ fontSize: 40, color: "#ffa8a8" }} />
                        <br />
                        <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                            <span>Error Loading # {jobid} ... try again?</span>
                        </Typography>
                    </div>
                )
            );
        } else {
            dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
            dispatch(resetDesigner());
        }
    } catch (error) {
        console.error("Error in loadDefaultJob:", error);
    }
};

export const HandlePageChange = ({
    force = false,
    dispatch,
    setJobToLoad,
    setLoadingDefaultJob,
    loadingDefaultJob,
    logged_user_code,
    loadedDefaultState,
    setLoadedDefaultState,
    user,
    page,
}) => {
    const url = window.location.href;

    if (url.includes("job=") && (!loadingDefaultJob || force)) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const job_id = urlParams.get("job");

        setJobToLoad(job_id);

        if (logged_user_code && user && (page === null || page === MAIN_PAGE)) {
            dispatch(changePage(DESIGNER_PAGE));
            dispatch(setDesignerLoadingBackdrop("Loading #" + job_id));
        }

        if (url.includes("static")) {
            dispatch({
                type: UPDATE_APP,
                parameter: "logged_user_code",
                value: "kevinchan@qikdraw.com.au.lld.bbccomms",
            });

            setLoadingDefaultJob(true);

            loadDefaultJob(job_id);
            setJobToLoad(null);
        }
    }

    if (!loadedDefaultState) {
        //

        setLoadedDefaultState(true);
        mergedState({}).then((result) => {
            //
            dispatch({
                type: "SET_STATE",
                value: result,
            });
        });
    }
};
